
import React, { useMemo, useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Modal, Select, DatePicker, Button, Spin } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
// Updated import for paginated table
import Table from "../../../core/pagination/Newdatatable";
import GRAN_LOGO1 from "../Logo/Granules_logo1.png";
import { getApiBaseUrl, ADD_ACTIVITY, LOGIN } from "../Config/Config";
import dayjs from "dayjs"; // Required for AntD RangePicker
import Swal from "sweetalert2";

const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterDryingCleaningReport = () => {
  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [downloadReportLoading, setDownloadReportLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [dataSource, setDataSource] = useState([]); // Paginated data for table
  const [selectedFilterId, setSelectedFilterId] = useState(0);
  const [selectedFilterName, setSelectedFilterName] = useState("All");

  // Use dayjs for RangePicker
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(7, "day"),
    dayjs(),
  ]);

  const [filters, setFilters] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);

  const user = JSON.parse(sessionStorage.getItem("user")) || {
    UserName: "Unknown User",
    UserID: null,
  };

  const reportConfig = useMemo(() => {
    const now = dayjs();
    const year = now.format("YYYY");
    const month = now.format("MM");
    const day = now.format("DD");
    const hours = now.format("HH");
    const minutes = now.format("mm");
    const seconds = now.format("ss");

    return {
      title: "Filter Cleaning Record",
      reportType: "Filter Cleaning",
      filename: `filter_cleaning_report_${year}-${month}-${day}_${hours}-${minutes}-${seconds}`,
      columns: [
        { title: "Filter ID", key: "Lable", dataIndex: "Lable" },
        { title: "Micron", key: "MicronRating", dataIndex: "MicronRating" },
        {
          title: "Filter Cleaning Details",
          children: [
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Compressed Air <br />
                  Pressure
                </div>
              ),
              key: "WashingAirPressure",
              dataIndex: "WashingAirPressure",
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  RO Water <br />
                  Pressure
                </div>
              ),
              key: "WashingRoWaterPressure",
              dataIndex: "WashingRoWaterPressure",
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Wash-in
                </div>
              ),
              key: "WashingTime",
              dataIndex: "WashingTime",
              render: (text) => formatDateTime(text),
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Wash-Out
                </div>
              ),
              key: "WashoutTime",
              dataIndex: "WashoutTime",
              render: (text) => formatDateTime(text),
            },
            {
              title: "Performed by",
              key: "WashoutUserEmail",
              dataIndex: "WashoutUserEmail",
            },
          ],
        },
        {
          title: "Filter Drying Details",
          children: [
            {
              title: "Dryer Temperature",
              key: "WashinDryerTemp",
              dataIndex: "WashinDryerTemp",
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Dry-In
                </div>
              ),
              key: "DryInTime",
              dataIndex: "DryInTime",
              render: (text) => formatDateTime(text),
            },
            {
              title: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                  Dry-Out
                </div>
              ),
              key: "DryOutTime",
              dataIndex: "DryOutTime",
              render: (text) => formatDateTime(text),
            },
            {
              title: "Performed by",
              key: "DryOutUserEmail",
              dataIndex: "DryOutUserEmail",
            },
          ],
        },
      ],
    };
  }, []);

  const formatDateTime = (text) => {
    if (!text) return "NA";
    const date = new Date(text);
    if (isNaN(date.getTime())) return "NA";
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
    return formatted.startsWith("01/01/1900") ? "NA" : formatted;
  };

  const formatDateForAPI = (dayjsObj) => {
    return dayjsObj.format("YYYY-MM-DD HH:mm:ss");
  };

  // Paginated fetch for table
  const fetchFilterCleaningData = async (page = 1, limit = 100) => {
    setLoading(true);
    try {
      const startDate = formatDateForAPI(dateRange[0]);
      const endDate = formatDateForAPI(dateRange[1]);
      const filterId = selectedFilterId || 0;

      const url = `${getApiBaseUrl()}/filterph2/FiltertimingReportpg?Filterid=${filterId}&startdate=${encodeURIComponent(
        startDate
      )}&enddate=${encodeURIComponent(endDate)}&pageNumber=${page}&recordslimit=${limit}`;

      const response = await fetch(url);
      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const list = data.ResultData || [];
        const keyedData = list.map((item, index) => ({
          ...item,
          key: item.Lable || item.ID || index,
        }));
        setDataSource(keyedData);
        if (list.length > 0 && list[0].TotalCount !== undefined) {
          setTotalRecords(list[0].TotalCount);
        } else {
          setTotalRecords(0);
        }
      } else {
        setDataSource([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Error fetching filter cleaning data:", error);
      setDataSource([]);
      setTotalRecords(0);
      // Swal.fire({
      //   icon: "error",
      //   title: "Error",
      //   text: "Failed to load data. Please try again.",
      // });
    } finally {
      setLoading(false);
    }
  };

  // Fetch ALL records for PDF
  const fetchAllDataForPDF = async () => {
    if (totalRecords === 0) return [];

    try {
      const startDate = formatDateForAPI(dateRange[0]);
      const endDate = formatDateForAPI(dateRange[1]);
      const filterId = selectedFilterId || 0;

      const url = `${getApiBaseUrl()}/filterph2/FiltertimingReportpg?Filterid=${filterId}&startdate=${encodeURIComponent(
        startDate
      )}&enddate=${encodeURIComponent(endDate)}&pageNumber=1&recordslimit=${totalRecords}`;

      const response = await fetch(url);
      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        return data.ResultData || [];
      }
      return [];
    } catch (error) {
      console.error("Error fetching full data for PDF:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/getFiltersListDropdown`);
        const data = await response.json();
        const result = data?.ResultData || [];
        setFilters(result);
      } catch (error) {
        console.error("Error fetching filters:", error);
        setFilters([]);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load filter list.",
        });
      }
    };
    fetchFilters();
  }, []);

  // Reload on filter/date change
  useEffect(() => {
    setCurrentPage(1);
    fetchFilterCleaningData(1, pageSize);
  }, [selectedFilterId, dateRange]);

  // Reload on pagination
  useEffect(() => {
    fetchFilterCleaningData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const tableColumns = useMemo(
    () =>
      reportConfig.columns.map((col) => ({
        title: col.title,
        dataIndex: col.dataIndex,
        key: col.key,
        children: col.children
          ? col.children.map((child) => ({
              title: child.title,
              dataIndex: child.dataIndex,
              key: child.key,
              render: child.render || ((text) => text || "-"),
            }))
          : undefined,
        render: col.render || ((text) => text || "-"),
      })),
    [reportConfig]
  );

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );

  const handleExportPDF = async () => {
    setDownloadReportLoading(true);

    const fullData = await fetchAllDataForPDF();

    const doc = new jsPDF({ orientation: "landscape" });
    const logoWidth = 15;
    const logoHeight = 15;
    const pageWidth = doc.internal.pageSize.getWidth();

    const generateHeader = () => {
      doc.addImage(GRAN_LOGO1, "PNG", 10, 10, logoWidth, logoHeight);
      doc.setFontSize(11);
      doc.text("Granules India Limited", 30, 14);
      doc.text("Gagillapur", 30, 20);
      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      doc.text(`Title: ${reportConfig.title}`, 10, 35);
      doc.setFont(undefined, "normal");
      return 42;
    };

    const startY = generateHeader();

    const headers = [
      [
        { content: "Filter ID", colSpan: 1 },
        { content: "Micron", colSpan: 1 },
        { content: "Filter Cleaning Details", colSpan: 5 },
        { content: "Filter Drying Details", colSpan: 4 },
      ],
      [
        "",
        "",
        "Compressed Air Pressure",
        "RO Water Pressure",
        "Wash-in",
        "Wash-Out",
        "Performed by",
        "Dryer Temperature",
        "Dry-In",
        "Dry-Out",
        "Performed by",
      ],
    ];

    autoTable(doc, {
      startY,
      head: headers,
      body:
        fullData.length > 0
          ? fullData.map((item) => [
              item.Lable || "NA",
              item.MicronRating || "NA",
              item.WashingAirPressure || "NA",
              item.WashingRoWaterPressure || "NA",
              item.WashingTime ? formatDateTime(item.WashingTime) : "NA",
              item.WashoutTime ? formatDateTime(item.WashoutTime) : "NA",
              item.WashoutUserEmail || "NA",
              item.WashinDryerTemp || "NA",
              item.DryInTime ? formatDateTime(item.DryInTime) : "NA",
              item.DryOutTime ? formatDateTime(item.DryOutTime) : "NA",
              item.DryOutUserEmail || "NA",
            ])
          : [[{ content: "No Data Available", colSpan: 11, styles: { halign: "center" } }]],
      theme: "grid",
      headStyles: { fillColor: [22, 160, 133], textColor: [255, 255, 255], halign: "center" },
      columnStyles: {
        0: { cellWidth: 20 },
        1: { cellWidth: 20 },
        2: { cellWidth: 30 },
        3: { cellWidth: 30 },
        4: { cellWidth: 22 },
        5: { cellWidth: 22 },
        6: { cellWidth: 22 },
        7: { cellWidth: 28 },
        8: { cellWidth: 22 },
        9: { cellWidth: 22 },
        10: { cellWidth: 22 },
      },
      margin: { top: startY, bottom: 35 },
      didDrawPage: generateHeader,
    });

    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.text(`Page ${i} of ${totalPages}`, pageWidth - 40, doc.internal.pageSize.height - 10);
      if (i === totalPages) {
        const footerY = doc.internal.pageSize.height - 20;
        doc.text("Remarks:", 10, footerY - 10);
        doc.text(`Printed by: ${user.UserName}`, 10, footerY);
        doc.text(
          `Date Range: ${dateRange[0].format("DD-MM-YYYY HH:mm")} - ${dateRange[1].format("DD-MM-YYYY HH:mm")}`,
          10,
          footerY + 6
        );
        doc.text(`Printed on: ${dayjs().format("DD-MM-YYYY HH:mm:ss")}`, 10, footerY + 12);
        doc.text(`Filter: ${selectedFilterName}`, 10, footerY + 18);
      }
    }

    const pdfBlob = doc.output("blob");
    const formData = new FormData();
    formData.append("file", pdfBlob, `${reportConfig.filename}.pdf`);

    fetch(`${getApiBaseUrl()}/api/uploadReportCopy`, { method: "POST", body: formData })
      .catch((err) => console.error("Upload failed:", err));

    doc.save(`${reportConfig.filename}.pdf`);
    setDownloadReportLoading(false);
  };

  const handlePasswordSubmit = async () => {
    if (!password) {
      setPasswordError("Please enter your password");
      return;
    }

    setAuthLoading(true);
    setPasswordError("");
    const username = user?.UserName || user?.Username;
    let loginSuccessful = false;

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const loginData = await loginRes.json();
      loginSuccessful = loginData?.Message === "Login successful";
    } catch (error) {
      setPasswordError("Something went wrong. Please try again.");
    }

    try {
      const activityPayload = {
        ActivityType: 1,
        PerformedBy: user?.UserID,
        PerformedOn: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        Notes: loginSuccessful
          ? `${reportConfig.title} downloaded by ${username}`
          : `Failed Reauthentication for ${reportConfig.title} by ${username}`,
        Location: "Reports",
        IsSucces: loginSuccessful ? 1 : 0,
      };
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(activityPayload),
      });
    } catch (err) {
      console.error("Activity log error:", err);
    } finally {
      setAuthLoading(false);
      if (loginSuccessful) {
        setVisible(false);
        setPassword("");
        handleExportPDF();
      }
    }
  };

  const handleFilterIdChange = (value) => {
    setSelectedFilterId(value);
    if (value === 0) {
      setSelectedFilterName("All");
    } else {
      const selected = filters.find((f) => f.ID === value);
      setSelectedFilterName(selected ? selected.Lable : "All");
    }
  };

  const handleDateRangeChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      setDateRange(dates);
    } else {
      setDateRange([dayjs().subtract(7, "day"), dayjs()]);
    }
  };

  return (
    <>
      {downloadReportLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ zIndex: 1050, backdropFilter: "blur(4px)", backgroundColor: "rgba(255,255,255,0.2)" }}
        >
          <Spin size="large" tip="Generating PDF with all records..." />
        </div>
      )}

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item" aria-current="page">
                      {reportConfig.title}
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your filter cleaning records</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link
                    to="#"
                    onClick={() => {
                      setVisible(true);
                      setPassword("");
                      setPasswordError("");
                    }}
                  >
                    <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap gap-3">
                <div style={{ width: 320 }}>
                  <Select
                    style={{ width: "100%" }}
                    value={selectedFilterId}
                    onChange={handleFilterIdChange}
                    placeholder="Select Filter ID"
                    showSearch
                    optionFilterProp="children"
                  >
                    <Option value={0}>All</Option>
                    {filters?.map((filter) => (
                      <Option key={filter?.ID} value={filter?.ID}>
                        {filter?.Lable}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <RangePicker
                    showTime={{ format: "HH:mm" }}
                    format="DD-MM-YYYY HH:mm"
                    value={dateRange}
                    onChange={handleDateRangeChange}
                    style={{ width: 350 }}
                  />
                  <Button
                    type="primary"
                    onClick={() => {
                      setCurrentPage(1);
                      fetchFilterCleaningData(1, pageSize);
                    }}
                    loading={loading}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : dataSource.length > 0 ? (
                  <Table
                    columns={tableColumns}
                    dataSource={dataSource}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    onPageChange={(page, size) => {
                      setCurrentPage(page);
                      setPageSize(size);
                    }}
                  />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <Modal
          title="Confirm Password"
          open={visible}
          onCancel={() => {
            setVisible(false);
            setPassword("");
            setPasswordError("");
          }}
          onOk={handlePasswordSubmit}
          confirmLoading={authLoading}
          okText="Verify & Download"
          width={350}
        >
          <div className="mb-3">
            <div className="pass-group">
              <input
                type={showPassword ? "text" : "password"}
                className={`form-control ${passwordError ? "is-invalid" : ""}`}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (passwordError) setPasswordError("");
                }}
                autoComplete="new-password"
                onCopy={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
              />
              <span
                className={`ti toggle-password ${showPassword ? "ti-eye" : "ti-eye-off"}`}
                onClick={() => setShowPassword((prev) => !prev)}
              ></span>
            </div>
            {passwordError && (
              <div className="invalid-feedback" style={{ display: "block" }}>
                {passwordError}
              </div>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};

export default FilterDryingCleaningReport;